<div class="main-navbar">
  <div id="mainnav">
    <div class="toggle-nav" (click)="mainMenuToggle()">
      <i class="fa fa-bars sidebar-bar"></i>
    </div>
    <ul class="nav-menu" [class.opennav]="navServices?.mainMenuToggle">
      <li class="back-btn">
        <div class="mobile-back text-end" (click)="mainMenuToggle()">
          <span>Voltar</span>
          <i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
        </div>
      </li>

      <li class="ng-star-inserted">
        <a class="nav-link menu" (click)="redirecionarHome()">Home</a>
      </li>
      <li class="ng-star-inserted">
        <a
          (click)="redirecionarSobre()"
          style="cursor: pointer"
          class="nav-link menu"
          >Sobre</a
        >
      </li>
      <li class="ng-star-inserted">
        <a
          (click)="redirecionarCadastreSe()"
          style="cursor: pointer"
          class="nav-link menu"
          >Cadastre-se</a
        >
      </li>
      <li class="ng-star-inserted">
        <a
          (click)="redirecionarSejaParceiro()"
          style="cursor: pointer"
          class="nav-link menu"
          >Seja Parceiro</a
        >
      </li>
      <li class="ng-star-inserted">
        <a
          (click)="redirecionarGuiaMonkey()"
          style="cursor: pointer"
          class="nav-link menu"
          >Guia Monkey</a
        >
      </li>
      <li class="ng-star-inserted">
        <a (click)="redirecionarFaleConosco()" class="nav-link menu"
          >Fale Conosco</a
        >
      </li>
      <!--  <li class="mega-menu-container">
        <a href="javascript:void(0)" class="nav-link"> Categorias </a>
        <ul class="nav-submenu">
          <li *ngFor="let item of menuCategorias">
            <a
              [routerLink]="['/shop/collection/left/sidebar']"
              [queryParams]="{ category: item.nome.replace(' ', '-') }"
              style="cursor: pointer"
            >
              {{ item.nome }}
            </a>
          </li>
        </ul>
      </li> -->
    </ul>
  </div>
</div>
